import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: { type: String }
  };

  static targets = ["primary", "secondary"];

  async copy() {
    try {
      try {
        await navigator.clipboard.writeText(this.contentValue);
      } catch {
        this.fallbackCopy(this.contentValue);
      }

      this.showFeedback();
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(textArea);
    }
  }

  showFeedback() {
    this.primaryTarget.classList.add("hidden");
    this.secondaryTarget.classList.remove("hidden");

    setTimeout(() => {
      this.primaryTarget.classList.remove("hidden");
      this.secondaryTarget.classList.add("hidden");
    }, 2000);
  }
}
